import { httpUtil, json2Obj } from "./httpUtil";
import { createCommonResult, createResult, ErrorCodes } from "./resultUtil";
import querystring from 'querystring';


export const paymentgateway = {
    getClientToken,
    addPaymentMethod,
    removePaymentMethod,
    createIntent,
    updateIntent,
    payment
}

async function getClientToken({ integration_id } = {}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.get({
            resourcePath: '/v1/contacts/' + id + '/client_token',
            queryParams: {
                integration_id
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        //console.log('response=1=====',response)
        if (response.code == 'OK') {
            return createCommonResult(response);
        }
    } catch (e) {
        console.log('Exception getClientToken: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function addPaymentMethod({
    name = 'PayPal',
    payment_method_type = 'WALLET',
    is_primary = true,
    is_backup = false,
    notes,
    email,
    integration_id,
    payment_method_nonce_token,
    gateway = 'BRAINTREE',
    card_info
}) {
    try {
        // debugger;
        let id = httpUtil.getSession().sub;
        let wallet = null;
        let card = null;
        if (payment_method_type == 'WALLET') {
            wallet = {
                email: email,
                gateway_token: [{
                    gateway: gateway ? gateway : null,
                    integration_id: integration_id,
                    token: payment_method_nonce_token
                }]
            }
        }
        if (payment_method_type == 'CARD') {
            card = {
                ...card_info,
                gateway_token: [{
                    integration_id: integration_id,
                    token: payment_method_nonce_token
                }]
            }
        }

        let response = await httpUtil.post({
            resourcePath: '/v1/contacts/' + id + '/payment_methods',
            body: {
                name,
                payment_method_type,
                is_primary,
                is_backup,
                notes,
                wallet,
                card
            },
        });
        //check return code here instead of put as there would be different intepretation for different API
        console.log('response=1=====', response)
        if (response.code == 'OK') {
            return createCommonResult(response);
        }
        else if (response.error && response.error.code && response.error.code == "CUSTOMER_EMAIL_ALREADY_EXIST") {
            return createResult(ErrorCodes.CUSTOMER_EMAIL_ALREADY_EXIST, response.error);
        }
        else {
            return createResult(ErrorCodes.UNKNOWN, response);
        }
    } catch (e) {
        console.log('Exception getClientToken: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function removePaymentMethod({
    payment_method_id,
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.sendDelete({
            resourcePath: '/v1/contacts/' + id + '/payment_methods/' + payment_method_id,
        });
        //check return code here instead of put as there would be different intepretation for different API
        console.log('response=1=====', response)
        if (response.code == 'OK') {
            return createCommonResult(response);
        }
    } catch (e) {
        console.log('Exception getClientToken: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function createIntent({
    payment_gateway,
    integration_id,
    payment_method_id,
    amount,
    currency
}= {}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: '/v1/contacts/' + id + '/intents',
            body: {
                payment_gateway,
                integration_id,
                payment_method_id,
                amount,
                currency
            },
        });
        return createCommonResult(response);
    } catch (ex) {
        return createResult(ErrorCodes.UNKNOWN, ex);
    }
}

async function updateIntent({
    client_secret,
    integration_id,
    action
} = {}) {
    try {

        let response = await httpUtil.put({
            resourcePath: '/v1/payment_intents/actions',
            body: {
                client_secret,
                integration_id,
                action
            },
        });
        return createCommonResult(response);
    } catch (ex) {
        return createResult(ErrorCodes.UNKNOWN, ex);
    }
}
async function payment({
    client_secret,
    amount,
    payment_method,
    account_id,
    external_payable_reference,
    action = "CAPTURE",
    currency_code,
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: '/v1/payments',
            body: {
                contact_id: id,
                client_secret,
                amount,
                payment_method : payment_method,
                external_payable: [{
                    "reference": external_payable_reference ? external_payable_reference : new Date().getTime(),
                }],
                action: action,
                account_id: account_id,
                currency_code: currency_code,
            },
        });
        return createCommonResult(response);
    } catch (ex) {
        return createResult(ErrorCodes.UNKNOWN, ex);
    }
}